import React from 'react'
import { IoIosCopy } from "react-icons/io";
import "./Icons.scss";
const CopyIcon = ({ className }) => {
    return (
        <div>
            <IoIosCopy className={className} />
        </div>
    )
}

export default CopyIcon